import script from "./Ad.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad.vue?vue&type=script&setup=true&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=3901c311&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3901c311"]])

export default __exports__